import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChangeEffectiveDate: {
        id: 'endorsement.eu.startChangePage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    policyChangeReason: {
        id: 'endorsement.eu.startChangePage.Policy Change Reason',
        defaultMessage: 'Policy Change Reason'
    },
    lossOccuredBetweenDates: {
        id: "endorsement.eu.startChangePage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    },
    policyChangeSource: {
        id: 'endorsement.eu.startChangePage.Policy Change Source',
        defaultMessage: 'Policy Change Source'
    },
    choosePolicyChangeSource: {
        id: 'endorsement.eu.startChangePage.Policy Change Source.Choose Policy Change Source',
        defaultMessage: 'Please Select'
    },
    choosePolicyChangeReason: {
        id: 'endorsement.eu.startChangePage.Policy Change Source.Choose Policy Change Reason',
        defaultMessage: 'Please Select'
    },
    policyChangeDescripion: {
        id: 'endorsement.eu.startChangePage.Description',
        defaultMessage: 'Description'
    },
    policyChangeCancelLabel: {
        id: 'endorsement.eu.startChangePage.CancelLabel',
        defaultMessage: 'Cancel'
    },
    policyChangesaveAndExitLabel: {
        id: 'endorsement.eu.startChangePage.SaveAndExitLabel',
        defaultMessage: 'Exit'
    },
    policyChangeEffectiveDateHelpText: {
        id: 'endorsement.eu.startChangePage.Effective Date for change can be modified in the Insured screen',
        defaultMessage: 'Effective Date for change can be modified in the Insured screen'
    }
});
